import {redirect} from "react-router-dom"

import {getToken, getPermissions} from "../utilities/useToken"

// Surveys are hidden from the regular Administrator UI; only an
// Enterprise Admin may reach the routes directly.
export const checkPreceptorAccess = () => {
    const {role} = getToken(true) || {}
    const permissions = getPermissions()

    if (role === "Preceptor" || permissions.allow_osrs) {
        return true;
    }

    throw new Error("Unauthorized")
}
